export default {"src":"/uk/_next/static/media/close.c08a45e8.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};